import { useCallback, useEffect, useRef, useState } from "react";
import "./discrepancyItemChatModal.scss";
import iconSendMsg from "../../../assets/send-msg.svg";
import {
  getDiscrepancyMessagesSvc,
  sendDiscrepancyMessageSvc,
} from "../../../Services/DiscrepancyServices";
import { HTTP_RESPONSE_CODES } from "../../../../../globals/globals";
import { subscribeSocket } from "../../../../../Sockets/socketsConnection";

export const DiscrepancyItemChatModal = ({
  onClose,
  discrepancyId,
  titleChat,
  channel,
}) => {
  const [messagesList, setMessagesList] = useState([]);
  const [message, setMessage] = useState("");
  const messagesContainerRef = useRef(null);
  const [client, setClient] = useState(null);
  const [userName, setUserName] = useState(localStorage.getItem("u_name"));

  // const [stompClient , setStompClient] = useState("")
  let stompClient;

  // functions

  useEffect(() => {
    setTimeout(() => {
      if (messagesContainerRef.current) {
        messagesContainerRef.current.scrollTop =
          messagesContainerRef.current.scrollHeight;
      }
    }, 0);
  }, [messagesList]);

  // DiscrepancyItemChatModal.jsx
useEffect(() => {
  if (discrepancyId) {
    subscribeSocket(`/kodo/discrepancy/${channel}/${discrepancyId}`, (msg) => {
      setMessagesList((prev) => [...prev, msg]);
    });
  }
}, [discrepancyId]);



  // useEffect(() => {
  //   const URL = "https://kodo-develop.aspsols.com"
  //   const stompClient = new Client({
  //     webSocketFactory: () => new SockJS(`${URL}/ws`),
  //     reconnectDelay: 3000,
  //     onConnect: () => {
  //       console.log("Connected to STOMP");
  //       stompClient.subscribe(`/kodo/discrepancy/${discrepancyId}`, (msg) => {
  //         const data = JSON.parse(msg.body);
  //         setMessagesList((prev) => [...prev, data]);
  //       });
  //     },
  //   });
  //   stompClient.activate();
  //   setClient(stompClient);

  //   return () => {
  //     stompClient.deactivate();
  //   };
  // }, [discrepancyId]);
  // function onConnected() {
  //   // Subscribe to the Public Topic
  //   stompClient.subscribe("/kodo/discrepancy/1", onMessageReceived);
  //   //stompClient.subscribe('/queue/' + username, onMessageReceived);
  // }

  // function onMessageReceived(payload) {
  //   let message = JSON.parse(payload.body);

  //   console.log(message);
  // }

  const getMessages = async () => {
    let request = await getDiscrepancyMessagesSvc(discrepancyId, channel);
    if (request.data.responseCode == HTTP_RESPONSE_CODES.SUCCESS) {
      setMessagesList(request.data.load);
    }
  };

  const sendMessage = async (body) => {
    let request = await sendDiscrepancyMessageSvc(body);
    if (request.data.responseCode == HTTP_RESPONSE_CODES.SUCCESS) {
      setMessage("");
      getMessages();
    }
  };

  const newMessage = useCallback(() => {
    if (!message.trim()) return;

    const body = {
      discrepancyId: parseInt(discrepancyId),
      // username: userName,
      content: message,
      channel: channel,
    };

    sendMessage(body);
  }, [message, discrepancyId, userName]);

  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.key === "Enter") {
        e.preventDefault();
        if (!message.trim()) {
          return
        }
        const body = {
          discrepancyId: parseInt(discrepancyId),
          // username: userName,
          content: message,
          channel: channel,
        };
        sendMessage(body);
      }
    };

    window.addEventListener("keydown", handleKeyDown);
    return () => window.removeEventListener("keydown", handleKeyDown);
  }, [sendMessage]);
  useEffect(() => {
    getMessages();
  }, []);
  return (
    <section className="discrepancy-item-modal-chat">
      <div className="discrepancy-item-modal-chat-title">
        <h3>{titleChat ?? "--"}</h3>
        <button>
          <i className="icon-cross" onClick={onClose}></i>
        </button>
      </div>
      <section
        className="discrepancy-item-modal-chat-messages-cont"
        ref={messagesContainerRef}
      >
        {messagesList.map((e, idx) => {
          return (
            <div
              key={idx}
              className={`item-discrepancy-msg ${
                e.sender.username == userName ? "own-message" : "vendor-message"
              }`}
            >
              <h3>{e.sender.username !== userName ? e.sender.username : ""}</h3>
              <p>{e.content}</p>
              <span>
                {new Date(e.createdAt).toLocaleTimeString([], {
                  hour: "2-digit",
                  minute: "2-digit",
                })}
                
              </span>
            </div>
          );
        })}
      </section>
      <span className="user-message-inp-cont">
        <input
          placeholder={"Type your message here…"}
          value={message}
          onChange={(e) => {
            setMessage(e.target.value);
          }}
        ></input>
        {/* <button onClick={newMessage}>
          {" "}
          <i className="icon-send-msg"></i>
        </button> */}
        <button onClick={newMessage}>
          <img src={iconSendMsg} alt="" srcset="" />
        </button>
      </span>
    </section>
  );
};
